(() => {
  const checkinHour = '#camping_guest_registration_form_checkin_time_4i';
  const checkinMinute = '#camping_guest_registration_form_checkin_time_5i';
  const dayTimeLastHour = '15';
  const lateTimeLastHour = '19';

  const init = () => {
    $('body').on('change', checkinHour, limitMinuteOfLastHour);
    if ($(checkinHour).val() === lateTimeLastHour || $(checkinHour).val() === dayTimeLastHour) {
      $(checkinMinute).prop('disabled', true);
    }
  }
  $(init);

  const limitMinuteOfLastHour = () => {
    if ($(checkinHour).val() === lateTimeLastHour || $(checkinHour).val() === dayTimeLastHour) {
      $(checkinMinute).val('00');
      $(checkinMinute).prop('disabled', true);
    } else {
      $(checkinMinute).prop('disabled', false);
    }
  }
})();

